// extracted by mini-css-extract-plugin
export default {"container":"Airspeed_container__AuZ-w","content":"Airspeed_content__svYMq"};